import React from "react";

import {
  IonText,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonButton,
} from "@ionic/react";

import { Link } from "react-router-dom";

import StationIcon from "../../assets/pages/station.svg";

import "./BusStationStyle.css";

interface BusStopProps {
  show?: boolean;
}

export const BusStation: React.FC<BusStopProps> = ({ show }) => {
  if (!show || show === undefined) {
    return null;
  }
  return (
    <div className="bus-station">
      {/* <IonCard className=""> */}
      <div className="bus-station-image">
        <img src={StationIcon} alt="Estação de espera" />
      </div>
      <IonCardHeader>
        <IonCardTitle style={{ textAlign: "center", marginBottom: "1rem" }}>
          <b>Olá</b>, agora você chegou ao ponto
          {/* <b> Marque sua viagem!</b> */}
        </IonCardTitle>
      </IonCardHeader>
      <IonCardContent style={{ display: "flex" }}>
        <Link className="link-scheduling" to="/page/passage-new">
          <IonButton className="button-scheduling">
            <IonText>Marcar viagem!</IonText>
          </IonButton>
        </Link>
      </IonCardContent>
    </div>
  );
};
